import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import './Table.css';

const LAYOUT = {
  1: {
    A: [
      'LACOLOMBE_TRIPLE_DRAFT',
      'SPINDRIFT_RASPBERRY_LIME',
      'LACOLOMBE_VANILLA_DRAFT',
      'BREW_DR_LOVE',
      'HARMLESS_COCONUT_WATER',
    ],
    B: [
      'GREEK_YOGURT_GRANOLA',
      'PESTO_PASTA_BOWL',
      'NORTH_NAPA_SALAD',
      'ALMOND_BUTTER_OATMEAL',
      'SOUTHWEST_SALAD',
      'PEACH_CAPRESE_SALAD',
    ],
  },
  2: {
    A: [
      'SMOKED_CHEDDAR_COBB',
      'GREEK_SALAD_NEW',
      'BUFFALO_RANCH_SALAD',
      'ASIAN_CHOPPED_SALAD',
      'SANTA_FE_SALAD',
    ],
    B: [
      'SESAME_CASHEW_NOODLE_BOWL',
      'SOUTHWEST_QUINOA_BOWL',
      'BROCCOLI_MAC_CHEESE',
      'SMOKED_CHEDDAR_BREAKFAST',
    ],
  },
  3: {
    A: [
      'CAULIFLOWER_FRIED_RICE',
      'MEDITERRANEAN_BOWL',
      'CHIPS_GUAC',
      'HARD_BOILED_EGGS',
    ],
    B: ['SEASONED_CHICKEN', 'CHOCOLATE_TRAIL_MIX', 'CHEDDAR_CHEESE'],
  },
  4: {
    A: [
      'TURKEY_CHEDDAR_SANDWICH',
      'CHICKEN_SALAD_WRAP_TWO',
      'HAM_CHEESE_HALF_SANDWICH',
      'BUFFALO_CHICKEN_WRAP',
    ],
    B: [
      'MAPLE_CHILI_NUT_MIX',
      'PHOENIX_BEAN_TOFU',
      'PINEAPPLE_CHIA_PUDDING',
      'BLUEBERRY_TEA_SQUARES',
    ],
  },
};

export default class SingleStop extends Component {
  constructor(props) {
    super(props);
    this.zoneitems = this.zoneitems.bind(this);
  }

  zoneitems(data, zone) {
    return Object.keys(data[zone]).reduce(
      (acc, currentValue) => acc + Math.max(1, data[zone][currentValue].length),
      0,
    );
  }

  render() {
    let LAYOUT_loc = JSON.parse(JSON.stringify(LAYOUT));
    const newItems = Object.keys(this.props.data).filter(
      (x) => this.props.data[x] > 0,
    );
    const itemLocation = Object.keys(LAYOUT_loc).reduce(function (
      accumulator,
      currentValue,
    ) {
      if (!accumulator[currentValue]) {
        accumulator[currentValue] = {};
      }
      accumulator[currentValue].A = LAYOUT_loc[currentValue].A.filter((x) =>
        newItems.includes(x),
      );
      accumulator[currentValue].B = LAYOUT_loc[currentValue].B.filter((x) =>
        newItems.includes(x),
      );
      return accumulator;
    },
    {});
    const allItems = Object.keys(LAYOUT_loc).reduce(function (
      accumulator,
      currentValue,
    ) {
      return accumulator
        .concat(LAYOUT_loc[currentValue].A)
        .concat(LAYOUT_loc[currentValue].B);
    },
    []);
    const diff = Object.keys(this.props.data)
      .filter((x) => !allItems.includes(x))
      .filter((x) => !allItems.includes(x));
    LAYOUT_loc = JSON.parse(JSON.stringify(itemLocation));
    if (diff.length > 0) {
      LAYOUT_loc.other = { A: [], B: diff };
    }

    const headers = [
      <tr key="header-table">
        <th key="Zone">Zone</th>
        <th key="Bay">Bay</th>
        <th key="Item">Item</th>
        <th key="Need">Need</th>
      </tr>,
    ];
    let rows = [];

    if (Object.keys(this.props.data).length > 0) {
      rows = Object.keys(LAYOUT_loc).map((zone) => (
        <tbody
          style={{ borderBottomWidth: 'thick', borderBottomColor: 'black' }}
          key={zone}
        >
          {Object.keys(LAYOUT_loc[zone]).map((bay, index) => {
            if (LAYOUT_loc[zone][bay].length === 0) {
              return (
                <tr key={bay + zone}>
                  {index === 0 && (
                    <td
                      style={{ verticalAlign: 'middle' }}
                      className="text-center"
                      rowSpan={this.zoneitems(LAYOUT_loc, zone)}
                    >
                      {zone}
                    </td>
                  )}
                  <td
                    style={{ verticalAlign: 'middle' }}
                    className="text-center"
                  >
                    {bay}
                  </td>
                  <td>{}</td>
                  <td>{}</td>
                </tr>
              );
            }
            return LAYOUT_loc[zone][bay].map((sku, bayIndex) => (
              <tr key={sku}>
                {bayIndex === 0 && index === 0 && (
                  <td
                    style={{ verticalAlign: 'middle' }}
                    className="text-center"
                    rowSpan={this.zoneitems(LAYOUT_loc, zone)}
                  >
                    {zone}
                  </td>
                )}
                {bayIndex === 0 && (
                  <td
                    style={{ verticalAlign: 'middle' }}
                    className="text-center"
                    rowSpan={LAYOUT_loc[zone][bay].length}
                  >
                    {bay}
                  </td>
                )}
                <td>{sku}</td>
                <td>{this.props.data[sku]}</td>
              </tr>
            ));
          })}
        </tbody>
      ));
    } else {
      rows = (
        <tr key="NO-Data">
          <td key="NO-Data"> No Data for this date</td>
        </tr>
      );
    }

    return (
      <div className="packingSlip">
        <Table responsive condensed>
          <thead>{headers}</thead>
          {rows}
        </Table>
        <p style={{ pageBreakBefore: 'always' }} />
      </div>
    );
  }
}
